/**
 * Asks, in the shared confirm dialog, whether unsaved changes may be dropped.
 *
 * @param {string} title
 * @param {string} body
 * @returns {Promise<boolean>} true when the user chose to discard
 */
export function confirmDiscard(title, body) {
    return document.querySelector('admin-confirm-dialog').ask({
        title,
        body,
        confirmLabel: 'Discard changes',
        cancelLabel: 'Keep editing',
        danger: true,
    });
}
